import { useOutlet } from 'react-router-dom';
import { useInternationalization } from '../../hooks';
import { routes } from '../../routes';
import { LayoutPage } from '../Layout';
import { LinkTab } from '../Tab';
import { PermissionKey } from '../../types';

export const CmsDetailAdmin = () => {
  const { t } = useInternationalization();
  const outlet = useOutlet();

  const tabs = [
    <LinkTab
      label={t('cms:sections.ads')}
      value={routes.Admin.Cms.Ads.path}
      permissions={{ keys: PermissionKey.CmsAdView }}
    />,
    <LinkTab
      label={t('cms:sections.publications')}
      value={routes.Admin.Cms.Publications.path}
      permissions={{ keys: PermissionKey.CmsNewsView }}
    />,
    <LinkTab
      label={t('cms:sections.helpTrainings')}
      value={routes.Admin.Cms.HelpTrainings.path}
      permissions={{ keys: PermissionKey.CmsHelpView }}
    />,
    <LinkTab
      label={t('cms:sections.staticPages')}
      value={routes.Admin.Cms.StaticPages.path}
      permissions={{ keys: [PermissionKey.CmsStaticView] }}
    />,
  ];
  return <LayoutPage display="Page" tabs={tabs} title={t('cms:title')} outlet={outlet}></LayoutPage>;
};
